class LTHKCartOptins extends HTMLElement {
  constructor() {
    super();
    // console.log('>>>>>> LTHLK - LTHKCartOptins Loaded 2');

    // this.querySelector('#accept_terms').addEventListener('click', function() {   
    //  console.log('CLICK');
    //   this.updateCheckoutButtonStatus;
    // });
  }

  connectedCallback() {
    // console.log('CONNECTED CALLBACK');
    this.init();
    this.watchCartChanges();
    this.watchDynamicCheckoutButtons(this.updateCheckoutButtonStatus);
  }

  init() {  
    // console.log('CONNECTED INIT');
    
    // Placez ici toute la logique initiale qui était dans DOMContentLoaded
    this.updateCheckoutButtonStatus = this.updateCheckoutButtonStatus.bind(this);
  
    this.checkoutButton = document.querySelector('[name="checkout"]');    
    this.shopPayButton = document.querySelector('.cart__dynamic-checkout-buttons div[role="button"]'); 

    this.termsCheckbox = this.querySelector('#accept_terms');
    //this.digitalTermsCheckbox = this.querySelector('#accept_digital_terms');
    this.digitalRetractationCheckbox = this.querySelector('#accept_retractation_terms');

    // console.log('checkout button : ', this.checkoutButton);
    // console.log('shopPayButton button : ', this.shopPayButton);

    // this.querySelector('#accept_terms').addEventListener('click', function() {   
    //  console.log('CLICK');
    //   this.updateCheckoutButtonStatus;
    // });

    // Attacher les écouteurs d'événements si les éléments existent
    if (this.termsCheckbox) {
      this.termsCheckbox.addEventListener('change', this.updateCheckoutButtonStatus);
    }
    //if (this.digitalTermsCheckbox) {
    //  this.digitalTermsCheckbox.addEventListener('change', this.updateCheckoutButtonStatus);
    //}
    if (this.digitalRetractationCheckbox) {
      this.digitalRetractationCheckbox.addEventListener('change', this.updateCheckoutButtonStatus);
    }

    this.updateCheckoutButtonStatus(); // Initial update

    this.hasProProducts = false
  }

  watchCartChanges() {
    const cartItems = document.getElementById('main-cart-items');
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            // Ici, vous pouvez mettre à jour l'affichage ou exécuter toute autre logique nécessaire
            console.log('Les éléments du panier ont changé');
            this.updateCheckoutButtonStatus()
            // Par exemple, mettre à jour un total du panier, réappliquer des coupons, etc.
          }
        });
      });

    observer.observe(cartItems, { childList: true, subtree: true });
  }

  watchDynamicCheckoutButtons(updateFunction) {
    // Fonction à exécuter lorsque des mutations sont observées
    var callback = function(mutationsList, observer) {
        for(var mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    // Vérifier si le noeud ajouté contient le bouton "ShopPay"
                    if (node.querySelector && node.querySelector('[data-testid="ShopifyPay-button"]')) {
                        console.log("Bouton 'ShopPay' détecté dans le DOM");
                        updateFunction();
                        // Effectuer des actions supplémentaires ici
                    }
                });
            }
        }
    };
    
    // Créer une instance de l'observateur avec une fonction de callback
    var observer = new MutationObserver(callback);
    
    // Options de configuration de l'observateur :
    var config = { attributes: false, childList: true, subtree: true };
    
    // Sélectionner le noeud cible pour observer les mutations
    var targetNode = document.querySelector('body'); // ou un sélecteur plus spécifique si nécessaire
    
    // Démarrer l'observation
    observer.observe(targetNode, config);
  }  

  // Fonction pour récupérer les tags d'un produit via son handle
  getProductTags(handle) {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => product.tags)
      .catch(error => {
        console.error(`Erreur lors de la récupération des tags pour le produit ${handle}:`, error);
        return [];
      });
  }

  updateCheckoutButtonStatus() {
    // console.log('>>>> updateCheckoutButtonStatus CALL 2');
    // Placez ici la logique de mise à jour du bouton de paiement
    // (le contenu de votre fonction existante updateCheckoutButtonStatus)

    this.shopPayButton = document.querySelector('[data-testid="ShopifyPay-button"]');
    // console.log('shopPayButton ??? : ', this.shopPayButton)

    let termsChecked = this.termsCheckbox.checked;
    let hasDigitalProducts = false;

    if (this.shopPayButton) {
      this.shopPayButton.classList.add('disabled-button');
    }

    // Vérifier si le panier contient des produits numériques
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        const self = this;

        // Teste si le panier contient des produits digitaux ou des produits pro
        cart.items.forEach((item) => {
          
          if (!item.requires_shipping) {
            hasDigitalProducts = true;
          }
          

          if (!self.hasProProducts) {
            const handle = item.handle;  // Récupérer le handle du produit
            self.getProductTags(handle).then(function(tags) {
              if (tags.includes('Produits réservés aux Pros de santé')) {
                self.hasProProducts = true
                // console.log(`>>>> Le produit ${item.title} a le tag 'Produits réservés aux Pros de santé'.`);
              }
            });
          }
          
        });

        console.log('HAS DIGITAL PRODUCT :', hasDigitalProducts)
        console.log('HAS PRO PRODUCT :', self.hasProProducts)
        console.log('lthk state :', lthk.state)

        //var digitalTermsCheckbox = document.getElementById('accept_digital_terms');
        //var digitalRetractationCheckbox = document.getElementById('accept_digital_retractation');

        const digitalProductChechboxWrappers = this.querySelectorAll('.digital-product-confirmation');
        
        if (hasDigitalProducts) {
          digitalProductChechboxWrappers.forEach(element => {
            element.style.display = 'block';
          });
          //var digitalTermsChecked = this.digitalTermsCheckbox.checked;
          var digitalRetractationChecked = this.digitalRetractationCheckbox.checked;

          // console.log('termsChecked, digitalTermsChecked, digitalRetractationChecked :', termsChecked, digitalTermsChecked, digitalRetractationChecked)

          
          //this.checkoutButton.disabled = !(termsChecked && digitalTermsChecked && digitalRetractationChecked);
          this.checkoutButton.disabled = !(termsChecked && digitalRetractationChecked);
        } else {
          digitalProductChechboxWrappers.forEach(element => {
            element.style.display = 'none';
          });
          
          this.checkoutButton.disabled = !(termsChecked);
        }

        if (self.hasProProducts && !lthk.state.isConnectedPro) {
          this.checkoutButton.disabled = true;
          console.log("Le panier contient des produits pro mais aucun pro n'est connecté");
        }

        if (this.shopPayButton) {
          if (this.checkoutButton.disabled) {
            this.shopPayButton.classList.add('disabled-button');
          } else {
            this.shopPayButton.classList.remove('disabled-button');
          }
        }
      });
  }

  // Vous pouvez ajouter d'autres méthodes au besoin
}

customElements.define('lthk-cart-optins', LTHKCartOptins);